import { CollectionSectionType } from '@/types/collection';
import { TemplateType, type ScreenType, type Section } from './types';

export const headerSection = {
  logo: {
    src: '/images/collection-editor/placeholders/logo.png',
  },
  background: {
    src: '/images/collection-editor/placeholders/hero.png',
  },
  description:
    'Game X is an exciting upcoming open-world exploration game built on the Beam platform. Immerse yourself in a rich, graphically-stunning sci-fi universe where adventure awaits at every turn. Assist your crew in thriving after a dramatic crash-landing and discover the secrets of a wild, uncharted world.',
};

export const introSection = {
  description:
    'Game X is an exciting upcoming open-world exploration game built on the Beam platform. Immerse yourself in a rich, graphically-stunning sci-fi universe where adventure awaits at every turn. Assist your crew in thriving after a dramatic crash-landing and discover the secrets of a wild, uncharted world.',
  gradient: ['#F89058', '#8640E9'],
};

export const footerSection = {
  title: 'Collect them all',
  description:
    'Venture into a world teeming with unique creatures and mysterious locales. Discover, hunt, and capture a diverse array of beings, each with special abilities. Train your finds to unlock their potential and strategically assemble the ultimate team. Explore, collect, and conquer in this thrilling alien world.',
  link: {
    label: '',
    value: '',
  },
};

export const availableSections: Section[] = [
  {
    type: CollectionSectionType.NFT_GALLERY,
  },
  {
    type: CollectionSectionType.TITLE_AND_TEXT,
    title: 'Where dreams and reality converge.',
    text: 'Join our community and check out the exclusive digital collection we offer. Stand out with unique items, secure early access with a beta invite, and stay ahead with the latest updates on game development.',
  },
  {
    type: CollectionSectionType.VIDEO_AND_IMAGE,
    image: { src: '/images/collection-editor/placeholders/image-collection.png' },
    video: {
      src: 'https://www.youtube.com/watch?v=VxgQpfGAy40',
    },
  },
  {
    type: CollectionSectionType.TEXT_AND_IMAGE,
    text: 'Earn in-game rewards through engaging gameplay, completing challenging quests, and achieving special milestones. Show your skills in exciting tournaments and events to win prizes.',
    image: { src: '/images/collection-editor/placeholders/text-and-image.png' },
  },
  {
    type: CollectionSectionType.VIDEO,
    video: { src: 'https://www.youtube.com/watch?v=VxgQpfGAy40' },
  },
  {
    type: CollectionSectionType.IMAGE_COLLECTION,
    title: 'Gaming empowered by cutting-edge technology',
    images: [
      {
        src: '/images/collection-editor/placeholders/image-collection.png',
        caption: 'This is a caption',
      },
      {
        src: '/images/collection-editor/placeholders/image-collection-2.png',
        caption: 'This is a caption',
      },
      {
        src: '/images/collection-editor/placeholders/image-collection-3.png',
        caption: 'This is a caption',
      },
    ],
  },
  {
    type: CollectionSectionType.TEXT,
    text: 'Embark on an epic adventure into an expansive world filled with mystery and wonder in Game X. Explore diverse and breathtaking landscapes, from ancient ruins to futuristic cities. Uncover hidden secrets, solve intricate puzzles, and encounter a variety of challenges along the way. Engage with interactive environments and dynamic elements that bring each area to life.',
  },
];

export const TEMPLATE_SECTIONS: { [key in TemplateType]: (CollectionSectionType | ScreenType)[] } =
  {
    [TemplateType.BASIC]: [CollectionSectionType.NFT_GALLERY, CollectionSectionType.TITLE_AND_TEXT],
    [TemplateType.MEDIUM]: [
      CollectionSectionType.NFT_GALLERY,
      CollectionSectionType.TITLE_AND_TEXT,
      CollectionSectionType.TEXT_AND_IMAGE,
      CollectionSectionType.IMAGE_COLLECTION,
    ],
    [TemplateType.EXTRA]: availableSections.map(section => section.type),
  };

export const getSections = (template: TemplateType, disabledSections?: CollectionSectionType[]) =>
  availableSections.filter(
    section =>
      TEMPLATE_SECTIONS[template].includes(section.type) &&
      !disabledSections?.includes(section.type),
  );
